import { useForm } from '@mantine/form';

import { prophetTypes } from '../types';
import { ChunkPlatform } from '../utils/chunk-limits';
import { validations } from '../validations';

export type KeywordRuleForm = ReturnType<typeof useKeywordRuleForm>;

type Props = {
  initialValues?: Pick<prophetTypes.KeywordRule, 'messages' | 'keyword'>;
  // Per-platform chunk limit context — see utils/chunk-limits.ts. Falls
  // back to telegram (char gate) for backward compat with callers that
  // don't pass platform yet.
  platform?: ChunkPlatform;
};

export const useKeywordRuleForm = ({ initialValues, platform = 'telegram' }: Props = {}) => {
  return useForm<Pick<prophetTypes.KeywordRule, 'messages' | 'keyword'>>({
    initialValues: {
      keyword: initialValues?.keyword || '',
      messages: {
        spreads: initialValues?.messages?.spreads || [],
        repeatedKeyword: initialValues?.messages?.repeatedKeyword || [],
      },
    },

    clearInputErrorOnChange: true,
    validate: {
      keyword: (v) =>
        !(v || initialValues?.keyword) ? `Поле Кодовое слово обязательно` : undefined,
      messages: (v) => {
        return (
          validations.messagesArray('Расклады', v.spreads) ||
          validations.messages('Расклады', v.spreads, undefined, platform) ||
          validations.messagesArray('Повторное кодовое', v.repeatedKeyword) ||
          validations.messages('Повторное кодовое', v.repeatedKeyword, undefined, platform) ||
          undefined
        );
      },
    },
  });
};
